import { DateFormats } from 'constants/common';
import moment from 'moment';
import { formatCurrency } from 'utils';
import { CreditAppTableRow, CustomerTableRow } from '../types';
import { CustomerStatus } from '@trnsact/trnsact-shared-types';
import { CustomerStatusChip } from '../ui/components';
import { ActionCell } from '../ui/pages/customerDetailsPage/tabs/creditAppsTab/ActionCell';

export const customersTableColumns = [
  {
    header: 'Company Name',
    renderKey: 'name',
    sortKey: 'name',
  },
  {
    header: 'Customer Name',
    renderKey: 'contactName',
    sortKey: 'contactName',
  },
  {
    header: 'Contact',
    renderKey: 'phone',
  },
  {
    header: 'Type',
    renderKey: 'type',
  },
  {
    header: 'Last Contact',
    renderKey: 'lastContactDate',
    sortKey: 'lastContactDate',
    renderCell: ({ lastContactDate }: CustomerTableRow) =>
      moment(lastContactDate).format(DateFormats.DateTimeShort12Hour),
  },
  {
    header: 'Status',
    renderKey: 'status',
    renderCell: ({ status }: CustomerTableRow) => <CustomerStatusChip status={status} />,
  },
  {
    header: 'Total Revenue',
    renderKey: 'totalRevenueAmount',
    sortKey: 'totalRevenueAmount',
    renderCell: ({ totalRevenueAmount }: CustomerTableRow) => formatCurrency(totalRevenueAmount),
  },
  {
    header: 'Active Deals',
    renderKey: 'activeDealsNumber',
    sortKey: 'activeDealsNumber',
  },
  {
    header: 'Opportunities',
    renderKey: 'opportunitiesNumber',
    sortKey: 'opportunitiesNumber',
  },
];

export const customerStatusChipSettings: Record<
  CustomerStatus,
  { color: string; bgColor: string; borderColor: string }
> = {
  [CustomerStatus.Active]: {
    color: '#43A047',
    bgColor: '#E8F5E9',
    borderColor: '#C8E6C9',
  },
};

export const creditAppsTableColumns = [
  {
    header: 'Date Received',
    renderKey: 'createdDateTime',
    renderCell: ({ createdDateTime }: CreditAppTableRow) =>
      moment(createdDateTime).format(DateFormats.DateTimeShort12Hour),
  },
  {
    header: 'Signed By',
    renderKey: 'signedBy',
  },
  {
    header: 'Sales Rep',
    renderKey: 'salesRep',
  },
  {
    header: 'Associated Location',
    renderKey: 'location',
  },
  {
    header: 'Associated Equipment',
    renderKey: 'equipment',
  },
  {
    header: 'Applying For',
    renderKey: 'applyingFor',
  },
  {
    header: 'Action',
    renderKey: 'action',
    renderCell: (row: CreditAppTableRow) => <ActionCell row={row} />,
  },
];
